export default "__VITE_ASSET__BOryzm55__"